// extracted by mini-css-extract-plugin
export default {"header":"WelcomeHeader_header__zadx0","title":"WelcomeHeader_title__Gagvi","subtitle":"WelcomeHeader_subtitle__kT+pq"};